import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { IPersonDetailState, PersonDetailState } from "./state.store";

import { PersonServices } from "../../../services/person.services";
import actions from "./actions.store";
import getters from "./getters.store";
import mutations from "./mutations.store";

export class PersonDetailModule<RootState>
  implements Module<IPersonDetailState, RootState> {
  namespaced: boolean;
  state: IPersonDetailState;
  getters: GetterTree<IPersonDetailState, RootState>;
  actions: ActionTree<IPersonDetailState, RootState>;
  mutations: MutationTree<IPersonDetailState>;

  /**
   *
   */
  constructor() {
    this.namespaced = true;
    this.state = new PersonDetailState({
      service: new PersonServices(),
      searchParam: {}
    });
    this.mutations = {
      ...mutations,
    };
    this.actions = {
      ...actions,
    };
    this.getters = {
      ...getters,
    };
  }
}
